export const TIME_FORMAT_STRING = "hh:mm A";
export const DATE_FORMAT_STRING = "DD MMM, YYYY";
export const DATE_FORMAT_STRING_WITH_DAY = "ddd, DD MMM, YYYY";
export const DATE_FORMAT_STRING_WITH_YEAR_FIRST = "YYYY-MM-DD";
export const SHORT_DATE_WITH_MONTH_DAY = "MMM DD";
export const SHORT_DATE_WITH_HOUR_MINUTE = "HH:mm";
export const DATE_FORMAT_STRING_FOR_HOUR_MINUTE_AM_PM = "hh:mm A";
export const SHORT_DATE_WITH_DAY_ONLY = "ddd";
export const TIME_LABELS = ["11:59 PM", "04:00 PM", "08:00 AM", "12:00 AM"];
